<template>
  <div v-if="schedules && schedules.length > 0">
    <div>
      <div
        v-for="schedule in schedules"
        :key="schedule.id"
        class="border-bottom"
      >
        <CaseSchedule
          :schedule-id="schedule.id"
          :case-id="current.id"
          @update-schedule-date="updateScheduleDate"
          @activate-schedule="activateSchedule"
          @complete-schedule="completeSchedule"
        ></CaseSchedule>
      </div>
    </div>
    <a
      class="btn btn-block my-btn p-3 svg-sm mt-2 red"
      v-if="current.status === 'active' && !showCreate"
      @click.prevent="showCreate = true"
    >
      <small class="uppercase">დამატებითი კონსულტაციის ჩანიშვნა</small>
      <ScheduleIcon></ScheduleIcon>
    </a>
    <div class="row mt-2" v-if="showCreate">
      <div class="col-12">
        <VueCtkDateTimePicker
          v-model="date"
          :inline="true"
          :no-keyboard="true"
          :no-button-now="true"
          :onlyDate="true"
          :first-day-of-week="1"
          :min-date="`${$moment().format('YYYY-MM-DD')}`"
          :locale="authLocale"
          format="YYYY-MM-DD"
        />
      </div>
      <div class="col-12" v-if="times">
        <div class="row no-gutters">
          <div
            class="col-auto text-center border mb-2 mx-2 py-2 rounded"
            style="width: 75px; user-select: none"
            @click.prevent="time = t"
            v-for="t of times"
            :key="t"
            :class="{
              'bg-primary text-white': time === t,
              'bg-warning text-white': isBooked(t),
            }"
          >
            <small class="py-3 px-2 pointer">{{ t }}</small>
          </div>
        </div>
      </div>
      <div class="col-6 mt-1" @click.prevent="saveSchedule">
        <button
          :disabled="!this.time || !this.date"
          class="btn btn-primary btn-block"
        >
          ჩანიშვნა
        </button>
      </div>
      <div class="col-6 mt-1" @click.prevent="showCreate = false">
        <button class="btn btn-secondary btn-block">გაუქმება</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import CaseSchedule from '@/components/Panel/Doctor/CaseSchedule'
import ScheduleIcon from '@/components/Icons/Schedule'
export default {
  components: {
    CaseSchedule,
    ScheduleIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      date: null,
      time: null,
      schedule_id: null,
      services: [],
      showCreate: false,
      taken: null
    }
  },
  computed: {
    ...mapGetters({
      authType: 'auth/type',
      authLocale: 'auth/locale',
      caseById: 'pcase/byId',
      schedules: 'schedule/schedules',
      scheduleById: 'schedule/byId'
    }),
    current () {
      return this.caseById(this.value)
    },
    service () {
      if (!this.current || this.services.length === 0) {
        return null
      }
      for (const s of this.services) {
        if (this.current.clinic_service_id === s.id) {
          return s
        }
      }
      return null
    },
    times () {
      const ret = []
      if (!this.date || !this.service || !this.service.availability) {
        return ret
      }
      const times = this.service.availability[this.date]
      if (!times) {
        return ret
      }
      let found = false
      for (const t of times) {
        const from = this.$moment(t.from).format('HH:mm')
        const to = this.$moment(t.to).format('HH:mm')
        for (let i = 0; i < 1440; i += this.service.duration) {
          let hour = '' + Math.floor(i / 60)
          let min = '' + (i % 60)
          if (hour.length === 1) {
            hour = '0' + hour
          }
          if (min.length === 1) {
            min = '0' + min
          }
          const time = `${hour}:${min}`
          if (time === from) {
            found = true
          }
          if (time === to) {
            found = false
          }
          if (found) {
            ret.push(time)
          }
        }
      }
      ret.sort((a, b) => {
        if (a > b) {
          return 1
        }
        return -1
      })
      return ret
    }
  },
  watch: {
    value () {
      this.fetchSchedules()
      if (this.authType === 'Doctor') {
        this.fetchAvailability()
        this.fetchAvailabilityTaken()
      }
    }
  },
  mounted () {
    this.fetchSchedules()
    if (this.authType === 'Doctor') {
      this.fetchAvailability()
      this.fetchAvailabilityTaken()
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setSchedule: 'schedule/set',
      resetSchedule: 'schedule/reset'
    }),
    updateScheduleDate (schedule_id) {
      const schedule = this.scheduleById(schedule_id)
      if (this.showCreate) {
        this.schedule_id = null
        this.date = null
        this.time = null
        this.showCreate = false
      } else {
        this.schedule_id = schedule_id
        this.date = this.$moment(schedule.start_time).format('YYYY-MM-DD')
        this.time = this.$moment(schedule.start_time).format('HH:ss')
        this.showCreate = true
      }
    },
    async activateSchedule (schedule_id) {
      try {
        this.loading = true
        const response = await this.axios.post(`/api/schedules/${schedule_id}/activate`)
        const schedule = response.data.data
        this.setSchedule({
          id: schedule.id,
          city_id: schedule.city_id,
          address: schedule.address,
          patient_id: schedule.patient_id,
          patient: schedule.patient,
          clinic_service_id: schedule.clinic_service_id,
          clinic_service: schedule.clinic_service,
          clinic_id: schedule.clinic_id,
          service_id: schedule.service_id,
          assignee_id: schedule.assignee_id,
          assignee: schedule.assignee,
          communication_days: schedule.communication_days,
          start_time: schedule.start_time,
          status: schedule.status,
          price: schedule.price,
          comment: schedule.comment,
          interview_id: schedule.interview_id,
          interview_status: schedule.interview_status,
          patient_case_id: schedule.patient_case_id,
          created_at: schedule.created_at,
          created_by: schedule.created_by
        })
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async completeSchedule (schedule_id) {
      try {
        this.loading = true
        const response = await this.axios.post(`/api/schedules/${schedule_id}/complete`)
        const schedule = response.data.data
        this.setSchedule({
          id: schedule.id,
          city_id: schedule.city_id,
          address: schedule.address,
          patient_id: schedule.patient_id,
          patient: schedule.patient,
          clinic_service_id: schedule.clinic_service_id,
          clinic_service: schedule.clinic_service,
          clinic_id: schedule.clinic_id,
          service_id: schedule.service_id,
          assignee_id: schedule.assignee_id,
          assignee: schedule.assignee,
          communication_days: schedule.communication_days,
          start_time: schedule.start_time,
          status: schedule.status,
          price: schedule.price,
          comment: schedule.comment,
          interview_id: schedule.interview_id,
          interview_status: schedule.interview_status,
          patient_case_id: schedule.patient_case_id,
          created_at: schedule.created_at,
          created_by: schedule.created_by
        })
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async saveSchedule () {
      try {
        this.loading = true
        if (this.schedule_id) {
          const params = {
            start_time: this.$moment(`${this.date} ${this.time}`).format()
          }
          const response = await this.axios.post(
            `/api/schedules/${this.schedule_id}/start-time`,
            params
          )
          const schedule = response.data.data
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          })
        } else {
          const params = {
            patient_id: this.current.patient_id,
            clinic_service_id: this.current.clinic_service_id,
            assignee_id: this.current.assignee_id,
            communication_days: this.current.schedule.communication_days,
            start_time: this.$moment(`${this.date} ${this.time}`).format(),
            interview_type: null,
            price: 0,
            patient_case_id: this.current.id
          }
          await this.axios.post('/api/schedules', params)
        }

        this.loading = false
        this.showCreate = false
        this.schedule_id = null
        this.date = null
        this.time = null
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async fetchAvailability () {
      try {
        this.loading = true
        const response = await this.axios.get('/api/doctor/availability')
        this.services = response.data.data
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    async fetchAvailabilityTaken (date) {
      try {
        this.loading = true
        const response = await this.axios.get('/api/doctor/availability/taken')
        this.taken = response.data.data
        console.log(this.taken)
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },

    async fetchSchedules () {
      this.resetSchedule()
      this.loading = true
      try {
        const response = await this.axios.get(
          `/api/patient-cases/${this.value}/schedules`
        )
        const schedules = response.data.data
        for (const schedule of schedules) {
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          })
        }
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    },
    isBooked (t) {
      let busy = []
      let found = false
      if (this.taken && this.taken[this.date]) {
        busy = this.taken[this.date]
      }
      for (const b of busy) {
        const from = this.$moment(b.from).format('HH:mm')
        const to = this.$moment(b.to).format('HH:mm')
        for (let i = 0; i < 1440; i += this.service.duration) {
          let hour = '' + Math.floor(i / 60)
          let min = '' + (i % 60)
          if (hour.length === 1) {
            hour = '0' + hour
          }
          if (min.length === 1) {
            min = '0' + min
          }
          const time = `${hour}:${min}`
          if (time === from) {
            found = true
          }
          if (time === to) {
            found = false
          }
          if (found) {
            if (t === time) {
              return true
            }
          }
        }
      }
      return false
    }
  }
}
</script>
